import React from 'react';
import { Card, Button, Badge } from 'react-bootstrap';
import { FaArrowLeft, FaTimesCircle } from 'react-icons/fa';
import { sectorTypeBadge, subtipoLabels, getOfferStagePresentation } from '../../utils/ofertasUtils';
import OfertasListActions from './OfertasListActions';

const getSubtypeLabel = (subtype) => {
    if (!subtype) return null;

    const normalizedSubtype = String(subtype);
    const mapped = subtipoLabels[normalizedSubtype];
    if (mapped) return mapped;

    return normalizedSubtype
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (char) => char.toUpperCase());
};

const OfferHeader = ({
    oferta,
    user,
    onNavigateBack,
    onAceptar,
    onImprimirContrato,
    onGestionArchivos,
    onVerNotas,
    onEnviarSignaturit,
    onSyncRenovacion,
    onRelanzar,
    onCancelar,
}) => {
    if (!oferta) return null;

    const subtypeLabel = getSubtypeLabel(oferta.sub_type_offer);
    // Obtener la presentación del estado de la oferta, incluyendo el manejo de errores de Signaturit
    const stagePresentation = getOfferStagePresentation(oferta);

    return (
        <Card className="detail-card detail-header mb-4">
            <Card.Body className="header-content">
                <div className="d-flex align-items-center gap-3">
                    <Button
                        variant="light"
                        className="rounded-circle shadow-sm p-2 d-flex align-items-center justify-content-center"
                        style={{ width: '40px', height: '40px' }}
                        onClick={onNavigateBack}
                    >
                        <FaArrowLeft className="text-secondary" />
                    </Button>
                    <div>
                        <h2 className="mb-1 fw-bold text-dark">Oferta {oferta.name}</h2>
                        <div className="d-flex align-items-center gap-2">
                            {sectorTypeBadge(oferta.sector_type)}
                            <Badge bg={stagePresentation.hasSignaturitError ? 'danger' : 'primary'} className="rounded-pill px-3 d-inline-flex align-items-center gap-2">
                                {stagePresentation.hasSignaturitError && <FaTimesCircle aria-hidden="true" />}
                                {stagePresentation.label}
                            </Badge>
                            {subtypeLabel && (
                                <Badge bg="light" text="dark" className="rounded-pill px-3 border">
                                    Subtipo: {subtypeLabel}
                                </Badge>
                            )}
                        </div>
                    </div>
                </div>
                <div className="header-actions">
                    <OfertasListActions
                        oferta={oferta}
                        userHasAgents={!!(user?.agents && user.agents.length)}
                        onAceptar={onAceptar}
                        onImprimirContrato={onImprimirContrato}
                        onGestionArchivos={onGestionArchivos}
                        onVerNotas={onVerNotas}
                        onEnviarSignaturit={onEnviarSignaturit}
                        onSyncRenovacion={onSyncRenovacion}
                        onRelanzar={onRelanzar}
                        onCancelar={onCancelar}
                    />
                </div>
            </Card.Body>
        </Card>
    );
};

export default OfferHeader;
